import { findAll } from 'highlight-words-core'
import type { FC } from 'react'
import { HighlightText } from '@/tools/ui'
import type { HighlightTextProps } from '@/tools/ui/components/highlight-text/HighlightText'

interface TextHighlighterProps {
  textToHighlight: string
  query?: string
  textClass?: string
  highlightedTextClass?: string
  color?: HighlightTextProps['color']
}

export const TextHighlighter: FC<TextHighlighterProps> = ({
  textToHighlight,
  query = '',
  textClass = '',
  highlightedTextClass = textClass,
  color = 'default',
}: TextHighlighterProps) => {
  const createChunks = () => {
    const searchWords = query.split(' ')
    const chunks = findAll({ searchWords, textToHighlight })
    return chunks.map(({ start, end, highlight }) => ({
      highlighted: highlight,
      text: textToHighlight.slice(start, end),
    }))
  }

  const chunks = createChunks()

  return (
    <p>
      {chunks.map(({ text, highlighted }, idx) =>
        highlighted ? (
          <HighlightText key={idx} color={color} text={text} textClass={highlightedTextClass} />
        ) : (
          <span key={idx} className={textClass}>
            {text}
          </span>
        )
      )}
    </p>
  )
}
